const navlist = [
    { title: "Home", link: "/" },
    { title: "Projects", link: "/projects" },
    { title: "Contact", link: "/contact" },
    { title: "Github", link: "https://github.com/taniyakamboj15" },
  ];
  export default navlist;
  